import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class EtudiantService {

    constructor(){
        this.adresse = new AdresseIP()
    }

    /*
     * Profil étudiant à partir de l'INE.
     * C'est la seule source correcte de idEtudiant : le champ "id" renvoyé
     * à la connexion est l'id du COMPTE utilisateur, pas celui de l'étudiant.
     */
    getByIne(codeIne) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-auth/hebergement-etudiant/'
        return axios.get(url+codeIne)
                    .then(res => res.data)
    }

}
